import { Delete, ModeEdit } from '@mui/icons-material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Toolbar from '@mui/material/Toolbar';

import Typography from '@mui/material/Typography';
import React, { MouseEvent, useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { defaultLabelDisplayedRows } from '../../communs/tablePaginationAssistant';
import AlertDialog from '../../componets/dialog/alertDialog';
import { FormButton } from '../../componets/form/formButton';
import { paths, rowsPerPageOptions } from '../../config';
import { useContextGlobal } from '../../context/ContextGlobal';
import { useToast } from '../../context/ToastContext';
import api from '../../services/api';
import { handleExceptionMessage } from '../../util/handleExceptionAxios';
import { message } from '../../util/handleMessages';
import { objToQuery, queryToObj } from '../../util/query';
import './configurationList.scss';
import { phoneMask } from '../../componets/form/mask/phone';
import { TableGeneric } from '../../componets/table';
import ListComponet from '../../componets/list';
import { IFormSettinsProps } from '../../componets/interfaces/formProps';
import { IconComponent, icons } from '../../componets/icons';
import { ColumnDef } from '@tanstack/react-table';
import { ImperativeHandleAccessedByParentListComponent } from '../../componets/interfaces/listProps';

interface Data {
    id: string;
    email: string;
    phoneNumber: string;
    phoneDdd: string;
    publicPlace: string;
    number: string;
    district: {
        description: string;
        state: string;
        cityName: string;
    };
}

interface HeadCell {
    disablePadding: boolean;
    id: keyof Data;
    label: string;
    numeric: boolean;
}

const headCells: readonly HeadCell[] = [
    {
        id: 'email',
        numeric: false,
        disablePadding: false,
        label: 'Email',
    },
    {
        id: 'phoneNumber',
        numeric: false,
        disablePadding: false,
        label: 'Telefone',
    },
    {
        id: 'publicPlace',
        numeric: false,
        disablePadding: false,
        label: 'Endereço',
    },
];

const ListEntity: React.FC<IFormSettinsProps> = props => {
    const { settings } = props;

    const refForm =
        React.useRef<ImperativeHandleAccessedByParentListComponent>(null);

    const columnsTable = React.useMemo<ColumnDef<Object>[]>(
        () => [
            {
                id: 'select',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Email
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            align="left"
                            key={row.id}
                            onClick={() =>
                                refForm?.current?.handleClick(row.original.id)
                            }>
                            {row.original?.email}
                        </TableCell>
                    );
                },
            },
            {
                id: 'select',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Telefone
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            align="left"
                            key={row.id}
                            onClick={() =>
                                refForm?.current?.handleClick(row.original.id)
                            }>
                            {handlePhone(row.original)}
                        </TableCell>
                    );
                },
            },
            {
                id: 'select',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Endereço
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            align="left"
                            key={row.id}
                            onClick={() =>
                                refForm?.current?.handleClick(row.original.id)
                            }>
                            {handleAddress(row.original)}
                        </TableCell>
                    );
                },
            },
            {
                id: 'select',
                header: ({ table }: any) => <TableCell align="center" />,
                cell: ({ row }: any) => (
                    <TableCell align="right">
                        <IconButton
                            onClick={() =>
                                refForm?.current?.handleEdit(row.original.id)
                            }>
                            <IconComponent icon={icons.ModeEdit} />
                        </IconButton>
                        <IconButton
                            onClick={() => {
                                refForm?.current?.setIdDelete(row.original.id);
                                refForm?.current?.setOpenModalDelete(true);
                            }}>
                            <IconComponent icon={icons.Delete} />
                        </IconButton>
                    </TableCell>
                ),
            },
        ],
        [],
    );

    const QUERY_DEFAULT = `page=1&limit=${rowsPerPageOptions[0]}`;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(0);
    const [rows, setRows] = useState<Data[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [query, setQuery] = useState<string>('');
    const [deleteRegister, setDeleteRegister] = useState<boolean>(false);
    const params = useParams<{ id?: string }>();
    const [openModalDelete, setOpenModalDelete] = useState(false);
    const [idDelete, setIdDelete] = useState<string>('');

    const history = useHistory();
    const { search } = useLocation();
    const { setOpenLoading } = useContextGlobal();
    const { addToast } = useToast();

    const loadRows = async (queryString: string): Promise<void> => {
        setOpenLoading(true);
        try {
            const response = await api.get(`configuration?${queryString}`);
            setRows(response.data.data);
            setTotal(response.data.count);
            setOpenLoading(false);
            if (deleteRegister) {
                setDeleteRegister(false);
            }
        } catch (error) {
            const messageResponse = handleExceptionMessage(error);
            addToast({
                type: 'error',
                title: message.error.selectAll,
                description: messageResponse,
            });
            setOpenLoading(false);
        }
    };

    useEffect(() => {
        let queryT = '';
        if (search && search.length > 0 && (!params || !params.id)) {
            const { limit, pageParam } = getParams();
            setRowsPerPage(Number(limit));
            setPage(Number(pageParam - 1));
            queryT = search.replace('?', '');
            setQuery(queryT);
        } else if (rowsPerPage === 0 && (!params || !params.id)) {
            let limit = rowsPerPage === 0 ? rowsPerPageOptions[0] : rowsPerPage;
            let currentPage = page + 1;
            const queryVO = {
                limit,
                page: currentPage,
            };
            const queryTemp = objToQuery(queryVO);
            history.push(`?${queryTemp}`);
        }

        if (queryT.length > 0) {
            loadRows(queryT);
        }
    }, [search]);

    useEffect(() => {
        const { limit, pageParam, description } = getParams();
        if (
            rowsPerPage > 0 &&
            (limit != rowsPerPage || page + 1 != pageParam)
        ) {
            let limit = rowsPerPage;
            let currentPage = page + 1;
            const queryVO = {
                limit,
                page: currentPage,
                description,
            };
            const queryTemp = objToQuery(queryVO);
            history.push(`?${queryTemp}`);
        }
    }, [page, rowsPerPage]);

    useEffect(() => {
        if (deleteRegister) {
            loadRows(query);
        }
    }, [deleteRegister]);

    const handleClick = (event: MouseEvent<unknown>, id: string) => {
        handleEdit(id);
    };

    function getParams() {
        let paramsQueryString = {
            limit: 0,
            pageParam: 0,
            page: 0,
            description: null,
        };
        if (search && search.length > 0) {
            paramsQueryString = queryToObj(search.replace('?', ''));
        }
        if (paramsQueryString.limit) {
            paramsQueryString.limit = Number(paramsQueryString.limit) || 0;
        }
        if (paramsQueryString.page) {
            paramsQueryString.pageParam = Number(paramsQueryString.page) || 0;
        }
        return paramsQueryString;
    }

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleEdit = (id: string) => {
        history.push(`${paths.configurationRegister}/${id}`);
    };
    const handleDelete = async (id: string) => {
        setOpenLoading(true);

        try {
            await api.delete(`configuration/${id}`);
            addToast({
                type: 'success',
                title: message.success.delete,
                description: '',
            });
            setPage(0);
            setRowsPerPage(rowsPerPageOptions[0]);
            setDeleteRegister(true);
        } catch (error: any) {
            const messageResponse = handleExceptionMessage(error);
            setOpenLoading(false);
            addToast({
                type: 'error',
                title: message.error.delete,
                description: messageResponse,
            });
        }
    };

    const handleConfirmeDelete = async (confirm: boolean) => {
        if (confirm) {
            setOpenModalDelete(false);
            handleDelete(idDelete);
            setIdDelete('');
        } else {
            setOpenModalDelete(false);
            setIdDelete('');
        }
    };

    const emptyRows = () => {
        if (rowsPerPage > rows.length) {
            return rowsPerPage - rows.length;
        }
        return 0;
    };

    const handleAddress = useCallback((register: Data) => {
        let address = '';
        if (register.publicPlace) {
            address = register.publicPlace;
        }
        if (register.number) {
            address = `${register.publicPlace}, ${register?.number} - ${register?.district.description} - ${register.district?.cityName}-${register.district.state}`;
        }
        return address;
    }, []);

    const handlePhone = useCallback((register: Data) => {
        let list = [];
        if (register.phoneNumber) {
            list.push(phoneMask(register.phoneNumber, false));
        }
        return list.join('');
    }, []);

    return (
        <ListComponet
            settings={settings}
            defaultValues={{}}
            columnsTable={columnsTable}
            inputsFilter={[]}
            mainInputsFilter={[]}
            QUERY_DEFAULT={QUERY_DEFAULT}
            ref={refForm}
        />
        // <div className="principal-container">
        //     <AlertDialog
        //         handleConfirmation={handleConfirmeDelete}
        //         open={openModalDelete}
        //     />
        //     <Box className={''}>
        //         <Paper sx={{ width: '100%', mb: 2 }}>
        //             <Toolbar
        //                 sx={{
        //                     pl: { sm: 2 },
        //                     pr: { xs: 1, sm: 1 },
        //                 }}>
        //                 <Typography
        //                     sx={{ flex: '1 1 100%' }}
        //                     variant="h6"
        //                     id="tableTitle"
        //                     component="div">
        //                     Configurações
        //                 </Typography>
        //             </Toolbar>
        //             <Typography
        //                 sx={{
        //                     pl: { xs: 1, sm: 2 },
        //                     pr: { xs: 1, sm: 1 },
        //                 }}>
        //                 <FormButton
        //                     label={'Novo'}
        //                     typeButton="addRegister"
        //                     onClick={() =>
        //                         history.push(paths.configurationRegister)
        //                     }
        //                 />
        //             </Typography>
        //             <TableContainer>
        //                 <Table
        //                     sx={{ minWidth: 750 }}
        //                     aria-labelledby="tableTitle"
        //                     size="small">
        //                     <TableHead>
        //                         <TableRow>
        //                             {headCells.map(headCell => (
        //                                 <TableCell
        //                                     key={headCell.id}
        //                                     align={
        //                                         headCell.numeric
        //                                             ? 'right'
        //                                             : 'left'
        //                                     }
        //                                     padding={
        //                                         headCell.disablePadding
        //                                             ? 'none'
        //                                             : 'normal'
        //                                     }>
        //                                     {headCell.label}
        //                                 </TableCell>
        //                             ))}
        //                             <TableCell />
        //                         </TableRow>
        //                     </TableHead>
        //                     <TableBody>
        //                         {rows.map(row => {
        //                             return (
        //                                 <TableRow
        //                                     hover
        //                                     role="checkbox"
        //                                     tabIndex={-1}
        //                                     key={row.id}>
        //                                     <TableCell
        //                                         align="left"
        //                                         onClick={event =>
        //                                             handleClick(event, row.id)
        //                                         }>
        //                                         {row.email}
        //                                     </TableCell>
        //                                     <TableCell
        //                                         align="left"
        //                                         onClick={event =>
        //                                             handleClick(event, row.id)
        //                                         }>
        //                                         {row.phoneDdd}
        //                                         {'-'}
        //                                         {row?.phoneNumber &&
        //                                             phoneMask(
        //                                                 row.phoneNumber,
        //                                                 false,
        //                                             )}
        //                                     </TableCell>
        //                                     <TableCell
        //                                         align="left"
        //                                         onClick={event =>
        //                                             handleClick(event, row.id)
        //                                         }>
        //                                         {handleAddress(row)}
        //                                     </TableCell>
        //                                     <TableCell align="right">
        //                                         <IconButton
        //                                             onClick={() =>
        //                                                 handleEdit(row.id)
        //                                             }>
        //                                             <ModeEdit />
        //                                         </IconButton>
        //                                         <IconButton
        //                                             onClick={() => {
        //                                                 setIdDelete(row.id);
        //                                                 setOpenModalDelete(
        //                                                     true,
        //                                                 );
        //                                             }}>
        //                                             <Delete />
        //                                         </IconButton>
        //                                     </TableCell>
        //                                 </TableRow>
        //                             );
        //                         })}
        //                         {emptyRows() > 0 && (
        //                             <>
        //                                 <TableRow
        //                                     style={{
        //                                         height: 53 * emptyRows(),
        //                                     }}>
        //                                     <TableCell colSpan={6}>
        //                                         {/* 1em é o mesmo tamanho do Icon svg */}
        //                                         <IconButton>
        //                                             <div
        //                                                 style={{
        //                                                     width: '1em',
        //                                                     height: '1em',
        //                                                 }}></div>
        //                                         </IconButton>
        //                                     </TableCell>
        //                                 </TableRow>
        //                             </>
        //                         )}
        //                     </TableBody>
        //                 </Table>
        //             </TableContainer>
        //             <TablePagination
        //                 rowsPerPageOptions={rowsPerPageOptions}
        //                 component="div"
        //                 count={total}
        //                 labelRowsPerPage={'Linhas por página'}
        //                 labelDisplayedRows={defaultLabelDisplayedRows}
        //                 rowsPerPage={rowsPerPage}
        //                 page={total > 0 ? page : 0}
        //                 onPageChange={handleChangePage}
        //                 onRowsPerPageChange={handleChangeRowsPerPage}
        //             />
        //         </Paper>
        //     </Box>
        // </div>
    );
};

export default ListEntity;
